var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#46B764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 9.4019L10.7143 16.4019C10.6533 16.4631 10.5809 16.5116 10.5011 16.5447C10.4213 16.5779 10.3358 16.5949 10.2494 16.5949C10.1631 16.5949 10.0775 16.5779 9.99777 16.5447C9.918 16.5116 9.84555 16.4631 9.78459 16.4019L6.72209 13.3394C6.66104 13.2784 6.61262 13.2059 6.57958 13.1261C6.54654 13.0464 6.52954 12.9609 6.52954 12.8746C6.52954 12.7882 6.54654 12.7027 6.57958 12.623C6.61262 12.5432 6.66104 12.4708 6.72209 12.4097C6.78313 12.3487 6.8556 12.3002 6.93536 12.2672C7.01512 12.2342 7.1006 12.2172 7.18693 12.2172C7.27326 12.2172 7.35874 12.2342 7.4385 12.2672C7.51826 12.3002 7.59073 12.3487 7.65177 12.4097L10.25 15.0079L16.7857 8.47331C16.909 8.35002 17.0762 8.28076 17.2505 8.28076C17.4249 8.28076 17.5921 8.35002 17.7154 8.47331C17.8387 8.59659 17.9079 8.7638 17.9079 8.93815C17.9079 9.1125 17.8387 9.27971 17.7154 9.40299L17.7143 9.4019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCheckIcon);
export default __webpack_public_path__ + "static/media/step_check_icon.0804722e0b482052a687d88753ec1da2.svg";
export { ForwardRef as ReactComponent };